import { create } from "zustand"

const useSearchParamStore = create((set) => ({
  searchParam: "",
  setSearchParam: (query) => set({ searchParam: query }),
  openModal: false,
  setOpenModal: (situacao) => set({ openModal: situacao }),
}))

export default useSearchParamStore
